<template>
    <div
        class="container"
        :class="{'slim': !full}"
    >
        <div
            class="content"
        >
            <section >
<!--                 <div v-if="full">
                  <h2
                    class="center"
                    v-html="$t('components.plans.title')"
                  />
                  <br>
                  <p
                      class="center"
                      v-html="$t('components.plans.subtitle')"
                  />
                </div>
                 <div v-else>
                  <h2
                    class="center"
                    v-html="'I piani dei kit ricette'"
                  />
                  <br>
                  <p
                      class="center"
                      v-html="'Per ogni ordine puoi scegliere il numero di persone e ricette, più ricette ordini più risparmi.'"
                  />
                </div>
                <br> -->
                <div
                    class="plans-listing flex flex-column flex-vcenter"
                >
                    <div
                        v-for="i in [2]"
                        :key="i"
                        class="plan-box-wrapper"
                    >

                        <div
                            class="plan-box shadow-box"
                        >
                            <!-- <v-img
                              class="col-8 offset-2 simulator-icon"
                              max-height="70%"
                              max-width="70%"
                              src="https://api.quomi.it/oldimg/Homepage1.png"
                            /> -->
                            <h2
                                class="center px-5"
                                v-html="!withoutTable && !onlyKitPricing ? $t('components.plans.title') : 'Più kit ricette ordini, più risparmi!'"
                            />
                            <span
                              class="center"
                              v-html="!withoutTable && !onlyKitPricing ? $t('components.plans.subtitle') : $t('components.plans.subtitle_alt')"
                            />
                            <!-- <div
                                class="plan-image"
                                v-if="full"
                            >
                                <h2
                                    class="plan-title"
                                    v-html="`${i === 2
                                        ? $t('components.plans.plan_for_two_title')
                                        : $t('components.plans.plan_for_four_title') } *`"
                                />
                            </div> -->

                            <div
                                class="plan-inner pt-10 flex flex-wrap justify-content-center"
                            > 
                              <div class="col-8 col-sm-4  flex flex-column">
                                <h4>Scegli il n° di Kit Ricette</h4>
                                <v-select
                                  v-model="value.recipes"
                                  :items="recipes"    
                                  dense
                                  solo
                                  @change="filterMeals"
                                  item-text="label"  
                                  item-value="value"
                                />
                              </div>
      
                              <div class="col-8 col-sm-4  flex flex-column">
                                <h4>Scegli le porzioni per ricetta</h4>
                                <v-select
                                  v-model="value.meals"
                                  :items="meals"    
                                  dense
                                  solo
                                  @change="onChangePlan"
                                  item-text="label"  
                                  item-value="value"
                                />                   
                              </div>
                                <!-- <div
                                    class="price-row"
                                    v-if="plansStore.plans"
                                > 

                                    <div><strong>Kit Ricette</strong></div>
                                    <br>
                                    <div
                                        class="flex flex-center"
                                    > 

                                    <div
                                          class="plan"
                                          v-for="(plan, index) in sortedPlans"
                                          :class="{ selected: plan.id === selectedPlanId[i] }"
                                          @click.stop="selectPlan(plan)"
                                          :key="index"
                                          v-if="plan.people === i && plan.meals > 0"
                                          :id="`plan-${plan.meals}-${plan.people}`"
                                          v-html="plan.meals"
                                    /></div> 

                                    <div class="mt-2">({{ portions(selectedPlanId[i]) }} porzioni)</div>
                                </div> 
                                 
                                <div
                                    class="plan-bottom flex flex-vcenter price-row"
                                    v-if="plansStore.plans"
                                > 
                                    <div> 
                                        <h5>
                                          {{ priceForPortion(selectedPlanId[i]) | priceFilter }}
                                        </h5> 
                                        <div
                                            class="info-small-normal"
                                            v-html="`${ $t('components.plans.for_portion') }`"
                                        />
                                    </div> 
                                    <div> 
                                        <div
                                            class="text-bold"
                                        >
                                        spedizione <br>{{ deliveryPrice(selectedPlanId[i]) | deliveryPriceFilter }}
                                        </div> 
                                        <div> 
                                            <img
                                                src="../assets/img/badges/plans/delivery-grey.png"
                                                class="delivery-icon"
                                            > 
                                        </div> 
                                    </div> 
                                    <div
                                        v-if='findPlan(selectedPlanId[i])'
                                    > 
                                        <h5>
                                          {{ findPlan(selectedPlanId[i]).price | priceFilter }}
                                        </h5>  
                                        <div
                                            class="info-small-normal"
                                            v-html="`prezzo piano`"
                                        /> 
                                    </div> 
                                </div> 
 -->
                                <!-- <div
                                    class="placeholder"
                                    v-if="!plansStore.plans"
                                    v-for="n in 4"
                                    :key="n"
                                /> -->
                            </div> 
                            <div class="col-12 col-sm-6 m-auto">
                              <h5 class="pt-3">
                                Prezzo a porzione<br>
                                {{ priceForPortion() | priceFilter }}
                              </h5>
                            <span class="info-small-normal">Prezzo Ricette: <b>{{ totalPlan | priceFilter }}</b></span>
                            <div class="flex flex-column">
                              <span class="info-small-normal">Costo di consegna*: <b>5,90€</b></span>
                              <span class="info-small-normal pt-3 tag-partner">(*Gratuita se attivi l'abbonamento)</span>
                            </div>
                            </div>

                        </div>
<!--                         <div
                            class="plan-i info-small center"
                            v-if="plansStore.plans"
                        >
                            <span
                                v-html="`${i === 2
                                    ? '* Piano adatto per 2 adulti o 2 adulti e un bambino fino a 10 anni'
                                    : '* Piano adatto per 2 adulti e 2 bambini fino a 10 anni, 2 adulti e un adolescente (10+) o 3 adulti'
                                }`"
                            />
                        </div> -->
                    </div>
                    <router-link :to="{name: 'flow-subscribed'}"
                      class="price-row flex-center"
                      v-if="plansStore.plans && full && !onlyKitPricing"
                    > 
                      <CTA
                        :content="$t('buttons.choose_plan')"
                        isArrow
                        @click="confirmPlan(i)"
                      />
                    </router-link> 
                </div>
            </section>

            <div v-if="!onlyKitPricing && !withoutTable">
              <table class="table table-striped table-borderless text-center rounded my-10 col-xl-8 offset-xl-2">
                <thead style="background: var(--quomi-primary); color: white">
                  <tr>
                    <th scope="col" v-for="header in headers" :key="header">
                      {{header.value}}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="price in prices" :key="price">
                    <th scope="row">{{price.portions}}</th>
                    <td>{{price.single}}</td>
                    <td>{{price.plan}}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="col-12 col-sm-10 offset-sm-1 my-10">
              <section style="padding-top: 0" v-if="!onlyKitPricing && !withoutTable ">
                <div id="first-content" class="first-content flex flex-vcenter">
                  <v-img
                  class="col-sm-6"
                    max-height="60%"
                    max-width="60%"
                    src="https://api.quomi.it/oldimg/Homepage2.png"
                  />
                  <div class="text-center col-sm-6">
                    <h2 class="text-center">Completa la tua spesa in Bottega!</h2>
                    <p class="px-3">Tanti prodotti artigianali, stagionali e di alta qualità ti aspettano ogni settimana.</p>
                  </div>
                </div>
              </section>

              <section class="tag-partner">
                <div class="second-content flex flex-vcenter" v-if="!onlyKitPricing">
                  <div class="text-center col-sm-6">
                    <h2 class="text-center">Con l'abbonamento hai sempre la consegna gratuita!</h2>
                    <p class="px-3">Scegli l’opzione in abbonamento per ricevere ogni 7, 14 o 28 giorni le tue ricette e cassette preferite a casa tua. <br><b>Nessun vincolo</b>, ti sospendi con un click. In più avrai sempre la <b>consegna gratuita!</b></p>
                  </div>
                  <v-img
                    class="col-sm-6"
                    max-height="60%"
                    max-width="60%"
                    src="https://api.quomi.it/oldimg/Homepage3_v2.png"
                  />
                </div>
              </section>
            </div>
<!--             <section v-if="full">
                <h2
                    class="center"
                    v-html="`Come riceverai la tua box`"
                />
                <p
                    class="center"
                    v-html="`Scegli il tipo di consegna che preferisci tra:`"
                />
                <usp
                  :template="'box'"
                />
            </section> -->

            <!-- <section>
                <h2
                    class="center"
                    v-html="`Perché scegliere i kit ricette?`"
                />
                <p
                    class="center"
                    v-html="``"
                />
                <usp
                  :template="'box-checkout'"
                />
            </section> -->

            <!-- <section v-if="full">
                <h2
                    class="center"
                    v-html="$t('components.usp.plans.title')"
                />
                <p
                    class="center"
                    v-html="$t('components.usp.plans.subtitle')"
                />
                <usp
                  :template="'plans'"
                />
            </section> -->

            <section v-if="full && menu && menu.recipes.length > 0">
                <h2
                    class="center"
                    v-html="$t('Un nuovo menù ogni settimana!')"
                />
                <p class="center">Ogni settimana ricette per soddisfare tutti i gusti. Tante idee e zero stress</p>
                <SliderQ
                    :minSizeOfSlide="300"
                    :maxNumSlides='3'
                    isCentered
                >
                    <slide v-for="(recipe, index) in sortedRecipes" :key="index">
                      <recipe-box
                        :item="recipe"
                        :isHover="false"
                      />
                    </slide>
                </SliderQ>
            </section>

            <section v-if="!onlyKitPricing">
                <opinions
                    :template="'plans'"
                />
            </section>
            
            <faq v-if="!onlyKitPricing"/>
            
            <center v-if="!onlyKitPricing">
              <CTA
                  :content="`Torna su`"
                  isArrowUp
                  @click="scroll()"
                />
            </center>
        </div>
    </div>
</template>

<script type = "text/javascript" >
import { scrollToTop } from '../assets/js/main.js'

import { dataLayer } from '../mixins/gtc'

import { plansStore } from '../store/plansStore' 
import { menuStore } from '../store/menuStore' 

import MenuAlert from './Checkout/MenuAlert'
import RecipeBox from './RecipeBox'
import Opinions from './Opinions'
import CTA from './Elements/CTA'
import Usp from './Usp'
import Faq from './Faq'

export default {

  props: {
    full: {
      type: Boolean,
      default: true
    },
    onlyKitPricing: {
      type: Boolean
    },
    withoutTable: {
      type: Boolean,
      default: false
    }
  },
  components: {
    RecipeBox,
    Opinions,
    MenuAlert,
    Faq,
    Usp,
    CTA
  },

  mixins: [
    dataLayer
  ],

  data () {
    return {
      selectedPlanId: {
        2: null,
        4: null
      },
      menuStore: menuStore.state,
      plansStore: plansStore.state,
      headers: [
        {
          value: "N° Porzioni",
        },
        {
          value: "Prezzo a porzione",
        },
        {
          value: "Prezzo del piano",
        }
      ],
      prices: [
        {
          portions: 2,
          single: "9,95 €",
          plan: "19,90 €"
        },
        {
          portions: 4,
          single: "7,03 €",
          plan: "28,10 €"
        },
        {
          portions: 6,
          single: "6,00 €",
          plan: "36,00 €"
        },
        {
          portions: 8,
          single: "5,50 €",
          plan: "44,00 €"
        },
        {
          portions: 10,
          single: "5,20 €",
          plan: "52,00 €"
        },
        {
          portions: 12,
          single: "5,00 €",
          plan: "60,00 €"
        },
        {
          portions: 14,
          single: "4,90 €",
          plan: "68,60 €"
        },
        {
          portions: 16,
          single: "4,75 €",
          plan: "76,00 €"
        },
        {
          portions: 18,
          single: "4,60 €",
          plan: "82,80 €"
        },
        {
          portions: 20,
          single: "4,45 €",
          plan: "89,00 €"
        },
      ],
      value: false,
      recipes: [],
      meals: [],
      plan: [],
      default: {
        meals: 2,
        recipes: 5
      },
    }
  },

  filters: {
    deliveryPriceFilter (val) {
      if (!val) return
      if (val === '0.00') return 'gratuita'
      return `€ ${val.replace('.', ',')} `
    },

    priceFilter (val) {
      if (!val) return
      return `€ ${val.toFixed(2).toString().replace('.', ',').replace(',00', '')}`
    }
  },

  watch: {
    'plansStore.plans' () {
      this.initial()
    },
    'this.meals' (){
      this.filterMeals()
    }
  },

  computed: {
    user () {
      return this.$root.user
    },
    menu () {
      return this.menuStore.menu
    },

    sortedRecipes () {
      return this.menu.recipes.sort((a, b) => { return a.isMixedBox ? 1 : -1 })
    },

    sortedPlans () {
      return this.plansStore.plans.sort((a, b) => (a.meals - b.meals))
    },

    totalPlan () {
      return this.plan ? this.plan.price : 0
    }
  },

  methods: {
    portions (id) {
      if (!id) return

      return this.findPlan(id).meals * this.findPlan(id).people
    },
    
    priceForPortion () {
      return +(this.plan.price / this.plan.meals / this.plan.people).toFixed(2)
    },

    deliveryPrice (id) {
      if (!id) return

      return this.findPlan(id).deliveryPrice

    },

    findPlan (id) {
      if (!this.plansStore.plans) return
      return this.plansStore.plans.find(p => p.id === id)
    },

    selectPlan (plan) {
      if (!plan) return
      this.plansStore.plans.forEach(p => { if (p.people === plan.people) p.selected = false })
      this.plansStore.plans.find(p => p.id === plan.id).selected = true
      this.selectedPlanId[plan.people] = plan.id
    },

    initial () {
      var plan

      plan = this.plansStore.plans.find(p => p.people === 2 && p.selected)
      if (plan) this.selectedPlanId['2'] = plan.id

      plan = this.plansStore.plans.find(p => p.people === 4 && p.selected)


      if (plan) this.selectedPlanId['4'] = plan.id
    },

    confirmPlan (i) {
      if (!i) return

      if (!this.selectedPlanId[i]) return

      var plan = this.findPlan(this.selectedPlanId[i])
      if (!plan) return

      var params = { people: plan.people, meals: plan.meals }
      this.$router.push({ name: 'flow-subscribed', params: params })
    },

    scroll () {
      scrollToTop()
    },

    filterMeals() {
      for(let i = 1; i <= 18; i++) {
        this.meals.push({value: i, label: `${i*2} porzioni`})
      }
      this.meals = this.meals.filter(el => (el.value*2) * this.value.recipes <= 36)
      this.loadPlan()
    },

    onChangePlan(){
      this.loadPlan()
    },

     loadPlan() {
      try {
        return plansStore.loadPlans().then(i => {
          return plansStore.findPlan({
            people: 2,
            meals: this.value.recipes * this.value.meals
          })
        }).then(i => {
          this.plan = i
        }) 
      } catch (e) {
        if (e.message != 'invalid meals quantity') {
          throw e
        }
        this.plan = [];
      }
    }
  },

  mounted () {
    if (this.plansStore.plans) this.initial()
    plansStore.loadPlans()
    //menuStore.loadCurrentMenu()

    for(let i = 1; i <= 18; i++) {
      this.meals.push({value: i, label: `${i*2} porzioni`})
    }

    for(let i = 1; i <= 10; i++) {
      this.recipes.push({value: i, label: `${i} ricette`})
    }

    this.value = this.default
    this.onChangePlan()
  }
}

</script>


<style scoped>

.content.banner {
  padding-top: 60px;
}
section + section {
  padding-top: 50px;
}

.container.slim {
  padding-top: 0 !important;
}

.content {
  max-width: 1300px;
}

h4 {
  font-size: 15px;
  text-align: center;
}

h5 {
  font-size: 25px;
  font-weight: bold;
  margin-bottom: 0;
}

.placeholder {
    background-color: #ededed;
    height: 30px;
    margin-top: 20px;
    margin-bottom: 20px;
}

.placeholder:nth-child(1) {
    margin-left: 50px;
    margin-right: 50px;
}

.placeholder:nth-child(2) {
    margin-left: 10px;
    margin-right: 10px;
}

.placeholder:nth-child(3) {
    margin-left: 30px;
    margin-right: 30px;
}

.placeholder:nth-child(4) {
    margin-left: 20px;
    margin-right: 20px;
}

.delivery-icon {
  padding-top: 5px;
  width: 25px;
  vertical-align: text-bottom;
}

.btn-small {
  width: 100%;
  margin: 0 auto;
  padding: 10px 0;
  border-radius: 6px;
}


.plans-listing {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
}

.price-row + .price-row {
  padding-top: 15px;
}

.price-row .btn {
  width: 100%;
}
.plan-inner {
  line-height: 1.1;
}

.plan-bottom {
  justify-content: center;
}

.plan-bottom > div  {
  padding: 10px;
  flex-basis: 12%;
}

.plan-bottom > div:nth-child(2) {
  border-left: 1px solid #ededed;
  border-right: 1px solid #ededed;
}

.plan {
  padding: 8px 16px;
  margin: 0 -1px;
  border: 2px solid #ededed;
  text-align: center;
  position: relative;
  cursor: pointer;
  font-size: 20px;
  font-weight: bold;
}

.price-row .plan:first-child {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

.price-row .plan:last-child {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

.plan.selected {
  border: 1px solid var(--quomi-primary);
  background: var(--quomi-primary);
  color: white;
}

.plan-box-wrapper {
  flex-grow: 1;
  flex-basis: calc(50% - 20px);
  width: 100%;
}

.plan-box {
  text-align: center;
  margin-bottom: 20px;
  height: auto;
  background-image: url("https://api.quomi.it/oldimg/quomi-piani2.jpg");
  background-repeat: no-repeat;
  background-size: cover;
}

.plan-box h2 {
  padding-top: 10%;
}

.plan-image::after {
  display: block;
  position: relative;
  background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0) 0, #000 100%);
  margin-top: -150px;
  height: 150px;
  width: 100%;
  content: '';
}

.plan-title {
  position: absolute;
  bottom: 10px;
  width: 100%;
  text-align: center;
}

h2.plan-title {
  color: white;
  text-align: center;
  z-index: 2;
  font-size: 22px;
  text-shadow: 3px 3px 7px black;
  font-weight: bold;
}

.btn-primary {
  margin: 0;
}

@media (max-width: 800px) {
  .content.banner {
    padding-top: 90px;
  }

  section {
    padding: 0 0 20px 0;
  }

  h5 {
    font-size: 20px;
  }

  .plan-image {
    height: 200px;
  }

  .plan-i {
    padding-bottom: 30px;
  }

  .plan-box {
  background-image: unset;
}

.plan-box h2 {
  padding-top: 5%;
}

  section + section {
    padding-top: 10px;
  }

  .first-content {
    flex-direction: column-reverse;
    align-items: center;
    margin-top: 30px;
  }

  .second-content {
    flex-direction: column;
    align-items: center;
    margin-top: 30px;
  }

}

@media (min-width: 1024px) {
  .simulator-icon {
    display: none;
  }
}
</style>
